import { useEffect, useState } from 'react'

export type CountdownParts = {
    total: number
    days: number
    hours: number
    minutes: number
    seconds: number
    done: boolean
}

const EMPTY: CountdownParts = {
    total: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    done: false
}

const diff = (targetMs: number): CountdownParts => {
    // No valid date set in the CMS: keep the zeros instead of showing NaN.
    if (Number.isNaN(targetMs)) return EMPTY

    const total = Math.max(0, targetMs - Date.now())
    const seconds = Math.floor((total / 1000) % 60)
    const minutes = Math.floor((total / 1000 / 60) % 60)
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
    const days = Math.floor(total / (1000 * 60 * 60 * 24))

    return { total, days, hours, minutes, seconds, done: total <= 0 }
}

export const useCountdown = (targetISO: string): CountdownParts => {
    const targetMs = new Date(targetISO).getTime()

    // SSR-safe initial value: zeros until hydrated, so server and client render the same markup.
    const [parts, setParts] = useState<CountdownParts>(EMPTY)

    useEffect(() => {
        setParts(diff(targetMs))

        const id = window.setInterval(() => setParts(diff(targetMs)), 1000)

        return () => window.clearInterval(id)
    }, [targetMs])

    return parts
}

export const pad = (n: number): string => n.toString().padStart(2, '0')
